const REFER_PROGRAM_LINKS = {
  EG: 'https://zyda-referral.typeform.com/to/q5dRughL',
  KW: 'https://zyda-referral.typeform.com/to/OXzi6i5v',
};

export default REFER_PROGRAM_LINKS;
